export const Styles = () => {
  return {
    image: {
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
      marginBottom: '1rem'
    },
    thankYouText: {
      marginBottom: '1rem'
    },
  };
};
